import React, { useEffect, useState } from "react";
import api, { openPdf } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, EmptyState, Loader } from "@/components/common";
import { money, fmtDate } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Bank, FilePdf } from "@phosphor-icons/react";

export default function Vouchers() {
  const { company } = useAuth();
  const cur = company?.currency || "KES";
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/vouchers").then((r) => setItems(r.data)); }, []);
  if (!items) return <Loader />;

  return (
    <div>
      <PageHeader title="Payment Vouchers" subtitle="Cheques issued to landlords & staff" icon={Bank} />
      {items.length === 0 ? (
        <EmptyState icon={Bank} title="No vouchers yet" message="Vouchers are generated when you pay landlords or staff commissions." />
      ) : (
        <Card className="overflow-hidden">
          <div className="overflow-x-auto">
            <Table>
              <TableHeader><TableRow>
                <TableHead>Voucher #</TableHead><TableHead>Payee</TableHead><TableHead>Type</TableHead>
                <TableHead>Cheque</TableHead><TableHead>Date</TableHead><TableHead className="text-right">Amount</TableHead><TableHead></TableHead>
              </TableRow></TableHeader>
              <TableBody>
                {items.map((v) => (
                  <TableRow key={v.id} data-testid={`voucher-row-${v.id}`}>
                    <TableCell className="font-mono text-sm">{v.voucher_number}</TableCell>
                    <TableCell className="font-medium">{v.payee_name}</TableCell>
                    <TableCell><Badge variant="outline">{v.payee_type}</Badge></TableCell>
                    <TableCell className="text-sm font-mono">{v.cheque_number || "—"}</TableCell>
                    <TableCell className="text-sm">{fmtDate(v.paid_date)}</TableCell>
                    <TableCell className="text-right font-mono">{money(v.amount, cur)}</TableCell>
                    <TableCell className="text-right"><Button size="icon" variant="ghost" onClick={() => openPdf(`/vouchers/${v.id}/pdf`)}><FilePdf size={16} /></Button></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </Card>
      )}
    </div>
  );
}
